<template>
  <v-bottom-navigation fixed v-model="bottomNavVal" grow color="#5cbbf6" @change="changeVal">
    <v-btn :value="0" @click="goHome" style="height:100%;">
      <span style="margin-top:-0.05rem;font-size:0.65rem !important;">主页</span>
      <v-icon size="27">mdi-home</v-icon>
    </v-btn>
    <v-btn :value="1" @click="goDeviceList" style="height:100%;">
      <span style="margin-top:0.08rem;font-size:0.65rem !important;">摄像机</span>
      <v-icon size="23" style="margin-top:0.2rem;">mdi-monitor-cellphone-star</v-icon>
    </v-btn>
    <v-btn :value="2" @click="goCamImageList" style="height:100%;">
      <span style="margin-top:0.01rem;font-size:0.65rem !important;">历史记录</span>
      <v-icon size="24" style="margin-top:0.19rem;">mdi-clipboard-text-outline</v-icon>
    </v-btn>
    <!-- <v-btn :value="3" @click="goUserProfile" style="height:100%;">
      <span style="margin-top:0.01rem;font-size:0.65rem !important;">我的</span>
      <v-icon size="25" style="margin-top:0.13rem;">mdi-account-circle</v-icon>
    </v-btn> -->
  </v-bottom-navigation>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {
      bottomNavVal: 0
    }
  },
  watch: {
    getCurVal() {
      var that = this
      that.bottomNavVal = that.$store.state.lastBnavVal
    }
  },
  computed: {
    getCurVal() {
      var that = this
      return that.$store.state.lastBnavVal
    }
  },
  mounted() {
    var that = this
    that.bottomNavVal = that.$store.state.lastBnavVal
  },
  created() {

  },
  methods: {
    goUserProfile() {
      this.$router.replace('/UserProfile')
    },
    goDeviceList() {
      this.$router.replace('/DeviceList')
    },
    goHome() {
      this.$router.replace('/Home')
    },
    goCamImageList() {
      this.$router.replace('/DeviceNotifyList')
    },
    changeVal() {
      var that = this
      that.$store.commit('SET_FNAVVAL', that.bottomNavVal)
    }
  }
}
</script>

<style scoped>
</style>
